import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import Draggable from "react-draggable";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useCart } from "react-use-cart";
import toast from "react-hot-toast";
import axiosInstance, { Homeurl } from "../../axiosInstance";
import { Swiper, SwiperSlide } from "swiper/react";
import Magnifier from "../components/extra/Magnifier";

import QuantitySelector from "../components/extra/QuantitySelector";

// import required modules
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";
import { useBlogContext } from "../../fetchdata/BlogContext";
import { Helmet } from "react-helmet";
import getCookie from "../../helper/getCookie";
import CreateSlug from "../components/extra/CreateSlug";
import getDecryptData from "../../helper/getDecryptData";
import HeaderPage from "../components/HeaderPage";
import NavBar from "../components/NavBar";

const ProductSlug = () => {


  const tableRef = useRef(null);


  const [tableData, setTableData] = useState({
    headers: [],
    rows: [],
  });



  const navigate = useNavigate();

  const [layout, setLayout] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [isProducts, setIsProducts] = useState(true);

  const [Products, setProducts] = useState([]);

  // const userId = localStorage.getItem('userId');
  const getdata = getDecryptData();
  const userId = getdata?._id || null;

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state

  const [SubmitWishlist, setWishlistLoading] = useState(true); // Add loading state

  const [SubmitCompare, setCompareLoading] = useState(true); // Add loading state

  const {
    Headers,
    isHeader,
    addItemToCart,
    cartItems,
    promoCodeInfo,
    updateItemQuantity,
  } = useBlogContext();

  const [selectedValues, setSelectedValues] = useState([]);

  const [ValuesVariant, setValuesVariant] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const [selectedCombination, setSelectedCombination] = useState({});

  const [ProductsRegular, setProductsRegular] = useState(0);
  const [ProductsSale, setProductsSale] = useState(0);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const { id, slug } = useParams();

  const [formData, setFormData] = useState({
    userId: userId || "",
    productId: id,
    rating: "",
    comment: "",
  });




  useEffect(() => {
    setIsLoading(true);
    setIsProducts(true);
    // Update the productId in the formData when id changes
    setFormData((prevState) => ({
      ...prevState,
      productId: id,
      rating: "",
      comment: "",
    }));
  }, [id]); // This useEffect will re-run whenever id changes


  const [selectedColor, setSelectedColor] = useState(""); // State to hold the selected color

  const [pdfBase64, setPdfBase64] = useState(""); // State to hold the PDF as Base64 string

  const [SelectedSizes, setSelectedSizes] = useState({});
  const [TotalQuantity, setTotalQuantity] = useState(1);

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const [thumbsVarSwiper, setThumbsVarSwiper] = useState(null);

  const [isOpenReview, setIsOpenReview] = useState(false);
  const [activeData, setActiveData] = useState([]);


  const [ChooseDateTime, setChooseDateTime] = useState(false);


  const toggleReviewPopup = () => {
    if (userId && getdata) {
      setIsOpenReview(!isOpenReview);
    } else {
      toast.error("Please Login First", TotalQuantity);
    }
  };

  const getProducts = async () => {
    const decryptdatajson = await getDecryptData();
    if (decryptdatajson && decryptdatajson?._id) {

      setEnquireData((prevData) => ({
        ...prevData,
        fullname: decryptdatajson.username,
        email: decryptdatajson.email,
        phone: decryptdatajson.phone,

      })); // Clear form fields
    }

    try {
      const { data } = await axiosInstance.get("/all-home-products");
      setProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  const getData = async () => {
    try {
      const { data } = await axiosInstance.get(`/home-layout-data`);
      setLayout(data.homeLayout);
      setIsLoading(false); // Set loading state to false in case of an error
    } catch (error) {
      console.log(error);
      toast.error("Error fetching Home layout!");
      setIsLoading(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getData();
    getProducts();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {

          setEnquireData((prevData) => ({
            ...prevData,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          })); // Clear form fields

          console.log("Latitude:", position.coords.latitude);
          console.log("Longitude:", position.coords.longitude);
        },

      );
    } else {
      toast.error('Geolocation is not supported by this browser.');
      return null;
    }



  }, [slug]);



  const handleAddToCart = async (product, buy) => {


    const existingProduct = cartItems.find((item) => item.id === product.id);
    if (existingProduct) {
      // const updatedQuantity = existingProduct.quantity + 1;
      const updatedQuantity = TotalQuantity;
      console.log("updatedQuantity", updatedQuantity);

      updateItemQuantity(
        existingProduct.id,
        cartItems.find((item) => item.id === existingProduct.id).quantity +
        updatedQuantity
      );

      if (buy) {
        navigate("/checkout");
      }
      toast.success("Product quantity updated in cart");
    } else {
      await addItemToCart(
        { ...product, color: selectedColor, TotalQuantity },
        TotalQuantity
      );

      // updateItemQuantity(product.id, updatedQuantity);

      if (buy) {
        navigate("/checkout");
      }
      // toast.success("Product Added To Cart");
    }

  };

  const handleBuyNow = (product) => {
    const buy = TotalQuantity;
    handleAddToCart(product, buy);
  };

  const [frontImage, setFrontImage] = useState(null);


  const [loading, setLoading] = useState(true); // Add loading state
  const [Image, setImage] = useState("");
  const [Specifications, setspecifications] = useState([]);

  const [mainImage, setMainImage] = useState("");

  const [Product, setProduct] = useState({});
  const [Attr, setAttr] = useState([]);
  const [sizeQuantities, setSizeQuantities] = useState({});
  const [variations, setVariations] = useState([]);
  const [Images, SetImages] = useState([]);

  const [variationsSize, setVariationsSize] = useState([]);
  const [Testimonial, setTestimonial] = useState([]);

  const [Varloading, SetVarLoading] = useState(true); // Add loading state
  const [ratings, setRatings] = useState([]);
  const [totalRating, settotalRating] = useState("");
  const [averageRating, setaverageRating] = useState("");
  const [HSNvariations, setHSNVariations] = useState({});
  const [selectedVariation, setSelectedVariation] = useState(null);

  const [variationsmap, setVariationsmap] = useState([]);
  const [prohsn, setprohsn] = useState("");

  const [activevariations, setactiveVariations] = useState({});

  const handleSmallImageClick = (newImageSrc) => {
    setFrontImage(newImageSrc);
  };

  const [enquireData, setEnquireData] = useState([]);
  const [dateTimeData, setDateTimeData] = useState([]);

  const getProduct = async () => {
    window.scrollTo(0, 0);
    setLoading(true); // Set loading to false when data is fetched
    SetVarLoading(true);

    console.log('__PRELOADED_DATA__', window.__PRELOADED_DATA__?.slug, slug);
    if (window.__PRELOADED_DATA__?.slug !== slug || window.__PRELOADED_DATA__ === undefined) {
      try {
        const { data } = await axiosInstance.get(`/user-product-slug/${slug}`);
        setProduct(data.Product);
        // setVariations(data.Product.variations.Color || []);
        // setVariationsSize(data.Product.variations.Size);
        SetImages(data.Product.images);
        setFrontImage(data.Product.pImage);
        setspecifications(data.Product.specifications.specifications || []);
        setSelectedValues(data.Product.variations);
        setProductCoverage(data.Product.coverage);
        setEnquireData((prevData) => ({
          ...prevData,
          service: data.Product?.title,
          category: data.Product?.Category,
        })); // Clear form fields
        setprohsn(data.Product.hsn || "");
        setActiveData(data.Product.variations);
        setValuesVariant(data.Product?.variant_products);
        setProductsRegular(data.Product?.regularPrice || 0);
        setProductsSale(data.Product?.salePrice || 0);
        setTestimonial(data.Product?.testimonials || []);
        const extraContent =
          Array.isArray(data.Product?.extra_content) &&
            data.Product.extra_content.length > 0 &&
            Array.isArray(data.Product.extra_content[0]?.headers) &&
            Array.isArray(data.Product.extra_content[0]?.rows)
            ? data.Product.extra_content[0]
            : { headers: [], rows: [] };

        setTableData(extraContent);

        const firstVisibleProduct = data.Product?.variant_products && data.Product?.variant_products.find(
          (product) => product.visible === true
        );

        if (firstVisibleProduct) {
          const {
            regular_price,
            sale_price,
            qty,
            visible,
            images,
            ...filteredProduct
          } = firstVisibleProduct;

          setSelectedCombination(filteredProduct);

          console.log("firstVisibleProduct", filteredProduct);

        }
        // getRating(data.Product._id);
      } catch (error) {
        console.error("Error getting product:", error);
        // navigate("/404");
      } finally {
        setLoading(false); // Set loading to false when data is fetched
        SetVarLoading(false);
        console.log("Image", Image);
      }
    } else {
      setLoading(false); // Set loading to false when data is fetched
      SetVarLoading(false);
      setIsLoading(false);

      setProduct(window.__PRELOADED_DATA__);
      // setVariations(data.Product.variations.Color || []);
      // setVariationsSize(data.Product.variations.Size);
      SetImages(window.__PRELOADED_DATA__.images);
      setFrontImage(window.__PRELOADED_DATA__.pImage);
      setspecifications(window.__PRELOADED_DATA__.specifications.specifications || []);
      setSelectedValues(window.__PRELOADED_DATA__.variations);
      setTestimonial(window.__PRELOADED_DATA__.testimonials || []);

      setEnquireData((prevData) => ({
        ...prevData,
        service: window.__PRELOADED_DATA__?.title,
      })); // Clear form fields

      // console.log("product data", data);
      setprohsn(window.__PRELOADED_DATA__.hsn || "");
      setActiveData(window.__PRELOADED_DATA__.variations);
      setValuesVariant(window.__PRELOADED_DATA__?.variant_products);
      setProductsRegular(window.__PRELOADED_DATA__?.regularPrice || 0);
      setProductsSale(window.__PRELOADED_DATA__?.salePrice || 0);
      const firstVisibleProduct = window.__PRELOADED_DATA__?.variant_products.find(
        (product) => product.visible === true
      );

      if (firstVisibleProduct) {
        const {
          regular_price,
          sale_price,
          qty,
          visible,
          images,
          ...filteredProduct
        } = firstVisibleProduct;

        setSelectedCombination(filteredProduct);

        console.log("firstVisibleProduct", filteredProduct);
      }

      setLoading(false); // Set loading to false when data is fetched
      SetVarLoading(false);
      // getRating();
    }


  };



  const handleIncrement = (stock) => {
    if (TotalQuantity <= stock) {
      // Check input length before updating

      setTotalQuantity(TotalQuantity + 1);
    } else {
      toast.error("Product out of stock. ");
    }
  };

  const handleDecrement = () => {
    if (TotalQuantity > 1) {
      setTotalQuantity(TotalQuantity - 1);
    }
  };

  const handleQuantityChange = (event) => {
    const newQuantity = parseInt(event.target.value);
    if (!isNaN(newQuantity) && newQuantity >= 1) {
      setTotalQuantity(newQuantity);
    }
  };

  useEffect(() => {
    // setVariationsmap([]); 
    getProduct();
    // getAttribute();
  }, [slug]);

  // product zoom js

  const [isZoomed, setIsZoomed] = useState(false);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [hoveredProduct, setHoveredProduct] = useState(null);

  const handleMouseEnter = (product) => {
    setIsZoomed(true);
    setHoveredProduct(product);
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
    setHoveredProduct(null);
  };

  const handleMouseMove = (e) => {
    setCursorPosition({
      x: (e.nativeEvent.offsetX / e.target.offsetWidth) * 100,
      y: (e.nativeEvent.offsetY / e.target.offsetHeight) * 100,
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const AddWhishlistData = async () => {
    setWishlistLoading(false);

    if (formData.userId === "") {
      toast.error("Please Login First");
      setWishlistLoading(true);
    } else {
      try {
        await axiosInstance.post("/add-wishlist", formData);
        toast.success("wishlist Added successfully!");
      } catch (error) {
        console.error("Error on wishlist added:", error);
        toast.error(error.response.data.message);
      } finally {
        setWishlistLoading(true);
      }
    }
  };

  const AddCompareData = async () => {
    setCompareLoading(false);

    if (formData.userId === "") {
      toast.error("Please Login First");
      setCompareLoading(true);
    } else {
      try {
        await axiosInstance.post("/add-compare", formData);
        toast.success("Comparsion Added successfully!");
      } catch (error) {
        console.error("Error on compare added:", error);
        toast.error(error.response.data.message);
      } finally {
        setCompareLoading(true);
      }
    }
  };

  const submitData = async () => {
    setSubmitLoading(false);

    if (!userId) {
      toast.error("Please Login First");
      setSubmitLoading(true);
      return;
    } else {
      if (formData.rating !== "" || formData.comment !== "") {
        const mydata = {
          rating: formData.rating,
          comment: formData.comment,
          userId: userId,
          productId: Product._id,
        }
        try {
          await axiosInstance.post("/add-rating", mydata);
          toggleReviewPopup();
          toast.success("Rating Added successfully!");

          const timer = setTimeout(() => {
            window.location.reload();
          }, 100);
          return () => clearTimeout(timer);

        } catch (error) {
          console.error("Error on rating added:", error);
          toast.error(error.response.data.message);
          setRatings([]);
        } finally {
          setSubmitLoading(true);
        }
      } else {
        toast.error("Please Fill All Fields");
        setSubmitLoading(true);
      }
    }
  };

  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  }

  const [MatchImages, setMatchImages] = useState([]);
  const [ProductVariantName, setProductVariantName] = useState("");
  const [ProductuniqueId, setProductuniqueId] = useState("");
  const [ProductCoverage, setProductCoverage] = useState([]);


  // Function to handle button click and update selected variant
  // Function to handle button click and update selected variant
  const handleVariantButtonClick_old = (name, value) => {
    const newSelectedCombination = { ...selectedCombination, [name]: value };
    setSelectedCombination(newSelectedCombination);
  };

  const handleVariantButtonClick = (name, value) => {

    // Update selected combination
    const newSelectedCombination = { ...selectedCombination, [name]: value };

    console.log('newSelectedCombination', newSelectedCombination);
    setSelectedCombination(newSelectedCombination);
  };

  useEffect(() => {
    const filteredVariants = ValuesVariant?.filter(
      (variant) => variant.visible === true
    );

    console.log("Filtered Variants:", filteredVariants);

    const allRowsSelected = selectedValues?.every((variant) =>
      variant.value.some((val) => selectedCombination[variant.name] === val)
    );

    const variantsWithId = filteredVariants?.map((variant, index) => ({
      ...variant,
      id: index + 1, // or use uuidv4() for unique id

    }));

    console.log("All Rows Selected:", allRowsSelected);

    if (allRowsSelected) {
      const matchedVariant = variantsWithId.find((variant) =>
        Object.keys(selectedCombination).every(
          (key) => variant[key] === selectedCombination[key]
        )
      );

      console.log("Matched Variant:", matchedVariant);

      if (matchedVariant) {
        const location = localStorage.getItem("location"); // Get location from localStorage

        // Add safety check for ProductCoverage
        const match = Array.isArray(ProductCoverage)
          ? ProductCoverage.find(item => item.city === location)
          : null;

        const coveragePrice = match ? Number(match.price) : 0;

        const regularPrice = Number(matchedVariant.regular_price);
        const salePrice = Number(matchedVariant.sale_price);

        setProductsRegular(regularPrice + coveragePrice);
        setProductsSale(salePrice + coveragePrice);

        console.log("Price:", matchedVariant.regular_price);
        console.log("Sale Price:", matchedVariant.sale_price);

        setProductuniqueId(matchedVariant.id);
        setMatchImages(matchedVariant.images);

        const { regular_price, sale_price, qty, visible, images, id, ...rest } = matchedVariant;

        const restString = `[ ${Object.entries(rest)
          .map(([key, value]) => `${key}: ${value}`)
          .join(", ")} ]`;
        setProductVariantName(" " + restString);
      } else {
        console.log("No matching variant found for the selected combination.");
      }

    } else {
      console.log("Not all combinations selected.");
    }
  }, [selectedCombination]);

  const removeSelectedFillter = () => {
    setSelectedCombination([]);
    setMatchImages([]);
    setProductsRegular(0);
    setProductsSale(0);
    setProductVariantName("");
    toast.success("Attribute Cleared Successfully");
  };

  const isCombinationPossible = (name, value) => {
    const newSelectedCombination = { ...selectedCombination, [name]: value };

    const visibleVariants = ValuesVariant?.filter((variant) => variant.visible);

    return visibleVariants.some((variant) =>
      Object.keys(newSelectedCombination).every(
        (key) =>
          !newSelectedCombination[key] ||
          variant[key] === newSelectedCombination[key]
      )
    );
  };

  const [EnquireShow, setEnquireShow] = useState(false);

  const [EnquireStatus, setEnquireStatus] = useState(false);

  const [StepForm, setStepForm] = useState(0);

  const handleNext = () => {
    setStepForm((prevStep) => prevStep + 1);
  };

  const handlePrevious = () => {
    setStepForm((prevStep) => prevStep - 1);
  };


  const enquireToggle = () => {
    if (EnquireShow) {
      setEnquireShow(false);
    } else {
      setEnquireShow(true);
    }
  };

  const dateTimeToggle = () => {
    if (ChooseDateTime) {
      setChooseDateTime(false);
    } else {
      setChooseDateTime(true);
    }
  };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    str = str.replace(/\d+/g, "");
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const validate = (email) => {
    // Regular expression to check for invalid characters
    const invalidCharsRegex = /[^\w@_.]| /; // Disallow spaces and any character that's not a word character, @, or .

    // Check for invalid cases
    if (email === "-" || email === "+") {
      return "";
    } else if (invalidCharsRegex.test(email)) {
      return ""; // Return empty string if invalid characters (including spaces) are found
    } else {
      return email; // Return the original email if valid
    }
  };




  const isVideo = (url) => {
    return /\.(mp4|webm|ogg)$/i.test(url);
  };


  return (
    <>
      <Header />

      <main className="page-content bg-light py-4" >

        <div className="d-sm-flex justify-content-between container-fluid py-3">
          <nav aria-label="breadcrumb" className="breadcrumb-row style-1">
            <ul className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="index.html"> Home</a>
              </li>

              <li className="breadcrumb-item"> </li>{Product && !isLoading ? (Product.title) : 'loading..'}
            </ul>
          </nav>
        </div>




        <div className=" ">



          <section className="content-inner py-0">
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-5 col-md-5">

                  <div className="border">
                    {frontImage && (
                      <>
                        <div className={`${MatchImages.length === 0 && "d-none"}`}>
                          <Swiper
                            onClick={togglePopup}
                            style={{
                              "--swiper-navigation-color": "#335599",
                              "--swiper-pagination-color": "#335599",
                            }}
                            spaceBetween={10}
                            navigation={true}
                            thumbs={{ swiper: thumbsVarSwiper }}
                            modules={[FreeMode, Navigation, Thumbs]}
                            className={`mySwiper2 hide-desk-pagenation ${isLoading && "d-none"
                              } `}
                          >
                            {MatchImages.map((imageUrl, index) => (
                              <SwiperSlide key={index}>
                                <div

                                >
                                  <img
                                    src={imageUrl.src}
                                    onMouseEnter={() =>
                                      handleMouseEnter(imageUrl.src)
                                    }
                                    onMouseLeave={handleMouseLeave}
                                    onMouseMove={handleMouseMove}
                                    className="m-auto d-block"
                                    alt="Product Image"
                                    style={{
                                      height: "auto",
                                      width: "100%",
                                      objectFit: "cover",
                                      cursor: "url(/assets/img/zoomm.png), auto",
                                      aspectRatio: '1/1',
                                      borderRadius: '20px',
                                      overflow: 'hidden'
                                    }}
                                  />
                                </div>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                          <Swiper
                            onSwiper={setThumbsVarSwiper}
                            spaceBetween={10}
                            slidesPerView={4}
                            freeMode={true}
                            watchSlidesProgress={true}
                            modules={[FreeMode, Navigation, Thumbs]}
                            className={`mySwiper ${isLoading && "d-none"}   `}
                          >
                            {MatchImages.map((imageUrl, index) => (
                              <SwiperSlide key={index}>
                                <img
                                  src={imageUrl.src}
                                  alt="Product Image"
                                  style={{
                                    aspectRatio: "1 / 1",
                                    objectFit: "cover",
                                  }}
                                  className="w-100"
                                />
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </div>
                      </>
                    )}

                    {frontImage && (
                      <>
                        <div className={`${MatchImages.length !== 0 && "d-none"}`}>
                          <Swiper
                            onClick={togglePopup}
                            style={{
                              "--swiper-navigation-color": "#335599",
                              "--swiper-pagination-color": "#335599",
                            }}
                            spaceBetween={10}
                            navigation={true}
                            thumbs={{ swiper: thumbsSwiper }}
                            modules={[FreeMode, Navigation, Thumbs]}
                            className={`mySwiper2 hide-desk-pagenation ${isLoading && "d-none"
                              }  ${MatchImages.length !== 0 && "d-none"}`}
                          >
                            <SwiperSlide>
                              <div className="overflow-hidden rounded">
                                {/\.(mp4|webm|ogg)$/i.test(frontImage) ? (
                                  <video
                                    src={frontImage}
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    className="m-auto d-block w-100"
                                    style={{
                                      height: "auto",
                                      width: "100%",
                                      objectFit: "cover",
                                      aspectRatio: "1 / 1",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={frontImage}
                                    onMouseEnter={() => handleMouseEnter(frontImage)}
                                    onMouseLeave={handleMouseLeave}
                                    onMouseMove={handleMouseMove}
                                    className="m-auto d-block"
                                    alt="Product Image"
                                    style={{
                                      height: "auto",
                                      width: "100%",
                                      objectFit: "cover",
                                      // cursor: "url(/assets/img/zoomm.png), auto",
                                      aspectRatio: "1 / 1",
                                    }}
                                  />
                                )}
                              </div>

                            </SwiperSlide>

                            {Images.map((mediaUrl, index) => (
                              <SwiperSlide key={index}>
                                <div className="overflow-hidden rounded">

                                  {isVideo(mediaUrl) ? (
                                    <video
                                      src={mediaUrl}
                                      autoPlay
                                      muted
                                      loop
                                      playsInline
                                      className="w-100"
                                      style={{
                                        aspectRatio: "1 / 1",
                                        objectFit: "cover",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={mediaUrl}
                                      onMouseEnter={() => handleMouseEnter(mediaUrl)}
                                      onMouseLeave={handleMouseLeave}
                                      onMouseMove={handleMouseMove}
                                      className="m-auto d-block"
                                      alt="Product Image"
                                      style={{
                                        width: "100%",
                                        aspectRatio: "1 / 1",
                                        objectFit: "cover",
                                      }}
                                    />
                                  )}

                                </div>
                              </SwiperSlide>
                            ))}


                          </Swiper>
                          <Swiper
                            onSwiper={setThumbsSwiper}
                            spaceBetween={10}
                            slidesPerView={4}
                            freeMode={true}
                            watchSlidesProgress={true}
                            modules={[FreeMode, Navigation, Thumbs]}
                            className={`mySwiper p-0 ${isLoading && "d-none"}  d-none `}
                          >
                            <SwiperSlide>
                              <img
                                src={frontImage}
                                alt="Product Image"
                                style={{
                                  aspectRatio: "1 / 1",
                                  objectFit: "cover",
                                }}
                                className="w-100"
                              />
                            </SwiperSlide>

                            {Images.map((mediaUrl, index) => (
                              <SwiperSlide key={index}>
                                <div className="overflow-hidden rounded">

                                  {isVideo(mediaUrl) ? (
                                    <video
                                      src={mediaUrl}
                                      autoPlay
                                      muted
                                      loop
                                      playsInline
                                      className="w-100"
                                      style={{
                                        aspectRatio: "1 / 1",
                                        objectFit: "cover",
                                        borderRadius: "12px",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={mediaUrl}
                                      onMouseEnter={() => handleMouseEnter(mediaUrl)}
                                      onMouseLeave={handleMouseLeave}
                                      onMouseMove={handleMouseMove}
                                      className="m-auto d-block"
                                      alt="Product Image"
                                      style={{
                                        width: "100%",
                                        aspectRatio: "1 / 1",
                                        objectFit: "cover",
                                      }}
                                    />
                                  )}

                                </div>
                              </SwiperSlide>
                            ))}


                          </Swiper>
                        </div>
                      </>
                    )}

                    {isLoading && (
                      <>
                        <div
                          className="card-1 skeleton w-100"
                          style={{ aspectRatio: '1/1', borderRadius: 20 }}
                        ></div>
                      </>
                    )}
                  </div>

                </div>
                <div className="col-xl-7 col-md-7">

                  <div className="product-details">
                    {/* Zoom overlay */}

                    {isZoomed && hoveredProduct && (
                      <div
                        className="zoom-overlay"
                        style={{
                          backgroundImage: `url(${hoveredProduct})`,
                          backgroundPosition: `${cursorPosition.x}% ${cursorPosition.y}%`,
                          backgroundColor: "white",
                        }}
                      ></div>
                    )}

                    <h1 className="product-title fs-3">
                      {Product && !isLoading ? (
                        <>{Product.title} </>
                      ) : (
                        <>
                          <div className=" border-bottom pb-2 mb-2 mt-2">
                            {" "}
                            <div
                              className="card-1 skeleton"
                              style={{ height: 32, borderRadius: 5 }}
                            ></div>
                          </div>
                        </>
                      )}
                    </h1>

                    <div className="border-bottom pb-2 mb-2 d-none">
                      {!averageRating || (!totalRating && !isLoading) ? (
                        <>
                          <span
                            className={`star-rating star-0 } fs-6 align-middle`}
                          />
                          <span className="d-inline-block fs-sm ms-2">
                            0 by 0 Reviews
                          </span>
                        </>
                      ) : (
                        <>
                          <span
                            className={`star-rating star-${averageRating * 2
                              } fs-6 align-middle`}
                          />
                          <span className="d-inline-block fs-sm ms-2">
                            {averageRating} by {totalRating} Reviews
                          </span>
                        </>
                      )}
                    </div>
                    {/* Product Price */}
                    <div className="product-price mb-3">
                      {Product && !isLoading ? (
                        <>
                          {ProductsSale ? (
                            <div className="row g-2">
                              <div className="col-auto d-flex flex-column justify-content-center">
                                <span className="text-accent fs-2">
                                  ₹{ProductsSale}
                                </span>
                              </div>
                              <div className="col d-flex flex-column justify-content-center">
                                <del className="text-body-secondary">
                                  <span className="fs-sm">
                                    ₹{ProductsRegular}
                                  </span>
                                </del>
                                <span className="text-danger fs-sm mt-n1">
                                  You save{" "}
                                  {Math.round(
                                    ((ProductsRegular - ProductsSale) /
                                      ProductsRegular) *
                                    100
                                  )}
                                  % (₹{ProductsRegular - ProductsSale})
                                </span>
                              </div>
                            </div>
                          ) : (
                            <>
                              <p className="text-danger fw-bold">
                                {" "}
                                Price On Request{" "}
                              </p>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="row g-2 mb-2">
                            <div
                              className="card-1 skeleton"
                              style={{
                                height: 56,
                                borderRadius: 10,
                                width: "50%",
                              }}
                            ></div>
                          </div>
                        </>
                      )}
                    </div>
                    {/* Product Price */}


                    <div class="variationsmapbutton mb-4 ">
                      {isLoading ? (
                        <>
                          {Array.from({ length: 1 }).map((_, index) => (
                            <div key={index}>
                              <div
                                className="card-1 skeleton mb-2"
                                style={{
                                  height: 20,
                                  width: 80,
                                  maxWidth: "100%",
                                  borderRadius: 5,
                                }}
                              ></div>
                              <div className="d-flex gap-2">
                                <div
                                  className="card-1 skeleton mb-2"
                                  style={{
                                    height: 40,
                                    width: 50,
                                    maxWidth: "100%",
                                    borderRadius: 5,
                                  }}
                                ></div>
                                <div
                                  className="card-1 skeleton mb-2"
                                  style={{
                                    height: 40,
                                    width: 50,
                                    maxWidth: "100%",
                                    borderRadius: 5,
                                  }}
                                ></div>
                              </div>
                            </div>
                          ))}
                        </>
                      ) : (
                        selectedValues &&
                        selectedValues.length > 0 &&
                        selectedValues.map((variant, index) => (
                          <div key={index} className="row d-block mb-2">
                            {variant.name === "Color" ? (
                              <>
                                <div className="col-md-12 mb-2 mb-2">
                                  {" "}
                                  <b> {variant.name} </b>
                                </div>
                                <div className="col-md-12">
                                  {variant?.value.length > 0 &&
                                    variant?.value.map((value, idx) => {
                                      const isActive =
                                        selectedCombination[variant.name] ===
                                        value;
                                      const isDisabled = !isCombinationPossible(
                                        variant.name,
                                        value
                                      );
                                      const firstVisibleProduct =
                                        ValuesVariant.find(
                                          (product) =>
                                            product.Color === value &&
                                            product.images.length !== 0
                                        );
                                      const firstImage =
                                        firstVisibleProduct?.images[0].src;

                                      return (
                                        <>
                                          {firstImage ? (
                                            <button
                                              key={idx}
                                              className={`img-button btn me-2 mb-2 ${isActive ? "active" : ""
                                                }`}
                                              onClick={() =>
                                                handleVariantButtonClick(
                                                  variant.name,
                                                  value
                                                )
                                              }
                                              disabled={isDisabled} // Disable if combination not possible
                                            >
                                              <img src={firstImage} width={80} />
                                              <span> {value} </span>
                                            </button>
                                          ) : (
                                            <button
                                              key={idx}
                                              className={`  btn me-2 ${isActive ? "active" : ""
                                                }`}
                                              onClick={() =>
                                                handleVariantButtonClick(
                                                  variant.name,
                                                  value
                                                )
                                              }
                                              disabled={isDisabled} // Disable if combination not possible
                                            >
                                              {value}
                                            </button>
                                          )}
                                        </>
                                      );
                                    })}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="col-md-12 mb-2 mb-2">
                                  {" "}
                                  <b> {variant.name} </b>
                                </div>
                                <div className="col-md-12">
                                  {variant?.value.length > 0 &&
                                    variant?.value.map((value, idx) => {
                                      const isActive =
                                        selectedCombination[variant.name] ===
                                        value;
                                      const isDisabled = !isCombinationPossible(
                                        variant.name,
                                        value
                                      );
                                      return (
                                        <button
                                          key={idx}
                                          className={`btn me-2 ${isActive ? "active" : ""
                                            }`}
                                          onClick={() =>
                                            handleVariantButtonClick(
                                              variant.name,
                                              value
                                            )
                                          }
                                          disabled={isDisabled} // Disable if combination not possible
                                        >
                                          {value}
                                        </button>
                                      );
                                    })}
                                </div>
                              </>
                            )}
                          </div>
                        ))
                      )}

                      <div></div>

                      {isLoading ? (
                        <div
                          className="card-1 skeleton mb-2"
                          style={{
                            height: 40,
                            width: 80,
                            maxWidth: "100%",
                            borderRadius: 5,
                          }}
                        ></div>
                      ) : (
                        <>
                          {Product?.type === true &&
                            selectedCombination.length !== 0 && (
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={removeSelectedFillter}
                              >
                                {" "}
                                <i className="ri-brush-3-fill"></i> Clear{" "}
                              </button>
                            )}
                        </>
                      )}


                    </div>
                    <hr />

                    {isLoading ? (
                      <>
                        <div
                          className="card-1 skeleton mb-2"
                          style={{
                            height: 50,
                            width: 400,
                            maxWidth: "100%",
                            borderRadius: 10,
                          }}
                        ></div>
                      </>
                    ) : (
                      <>

                        <div className="text-start mb-3">

                          <div className="quantity-products d-inline-flex p-2 rounded align-items-center" style={{ border: '1px solid black' }}>
                            {/* Decrement Button */}
                            <button
                              className="btn btn-sm btn-dark p-2"
                              onClick={handleDecrement}
                              aria-label="Decrement quantity"
                            >
                              <i className="ri-subtract-line" />
                            </button>

                            {/* Quantity Input */}
                            <input
                              id="quantityNumber1"
                              className="quantity-number form-control-sm text-center border-0"
                              type="number"
                              value={TotalQuantity}
                              max={Product?.stock} // max quantity based on stock
                              min={1} // Prevent entering numbers less than 1
                              onChange={handleQuantityChange}
                              aria-label="Product quantity"
                            />

                            {/* Increment Button */}
                            <button
                              className="btn btn-sm btn-dark  p-2"
                              onClick={() => handleIncrement(Product?.stock)}
                              aria-label="Increment quantity"
                            >
                              <i className="ri-add-line" />
                            </button>
                          </div>

                        </div>

                        <div className="btn-group cart-btn gap-2">
                          <button type="button"
                            onClick={() => {
                              if (Product.type) {
                                if (ProductsSale === 0) {
                                  toast.error("Please Choose Attribute");
                                } else {
                                  handleAddToCart({
                                    id: Product._id + ProductuniqueId,
                                    title: Product.title + ProductVariantName,
                                    image:
                                      MatchImages.length !== 0
                                        ? MatchImages[0].src
                                        : frontImage, // Remove the extra dot
                                    regularPrice: ProductsRegular,
                                    price: ProductsSale,
                                    color: selectedColor,
                                    customise: pdfBase64,
                                    TotalQuantity: TotalQuantity,
                                    weight: Product.weight,
                                    gst: Product.gst,
                                    stock: Product.stock,
                                    pid: Product._id,
                                  });
                                }
                              } else {
                                handleAddToCart({
                                  id: Product._id + ProductuniqueId,
                                  title: Product.title + ProductVariantName,
                                  image:
                                    MatchImages.length !== 0
                                      ? MatchImages[0].src
                                      : frontImage, // Remove the extra dot
                                  regularPrice: ProductsRegular,
                                  price: ProductsSale,
                                  color: selectedColor,
                                  customise: pdfBase64,
                                  TotalQuantity: TotalQuantity,
                                  weight: Product.weight,
                                  gst: Product.gst,
                                  stock: Product.stock,
                                  pid: Product._id,
                                });
                              }
                            }}
                            className="btn btn-secondary btn-lg text-uppercase">
                            Add To Cart
                          </button>
                          <button
                            onClick={() => {
                              if (Product.type) {
                                if (ProductsSale === 0) {
                                  toast.error("Please Choose Attribute");
                                } else {
                                  handleBuyNow({
                                    id: Product._id + ProductuniqueId,
                                    title: Product.title + ProductVariantName,
                                    image:
                                      MatchImages.length !== 0
                                        ? MatchImages[0].src
                                        : frontImage, // Remove the extra dot
                                    regularPrice: ProductsRegular,
                                    price: ProductsSale,
                                    TotalQuantity: TotalQuantity,
                                    weight: Product.weight,
                                    gst: Product.gst,
                                    stock: Product.stock,
                                    pid: Product._id,
                                  });
                                }
                              } else {
                                handleBuyNow({
                                  id: Product._id + ProductuniqueId,
                                  title: Product.title + ProductVariantName,
                                  image:
                                    MatchImages.length !== 0
                                      ? MatchImages[0].src
                                      : frontImage, // Remove the extra dot
                                  regularPrice: ProductsRegular,
                                  price: ProductsSale,
                                  color: selectedColor,
                                  customise: pdfBase64,
                                  TotalQuantity: TotalQuantity,
                                  weight: Product.weight,
                                  gst: Product.gst,
                                  stock: Product.stock,
                                  pid: Product._id,
                                });
                              }
                            }}

                            type="button"
                            className="btn btn-outline-secondary btn-lg btn-icon"
                          >
                            <i className="ri-shopping-bag-3-line" />  Buy Now
                          </button>
                        </div>


                      </>
                    )}

                    <div className="d-none">
                      {isLoading ? (
                        <>
                          <div className="row" style={{ maxWidth: 300 }}>
                            <div className="col-6">
                              <div
                                className="card-1 skeleton mb-2"
                                style={{
                                  height: 50,
                                  width: "100%",
                                  borderRadius: 10,
                                }}
                              ></div>
                            </div>
                            <div className="col-6">
                              <div
                                className="card-1 skeleton mb-2"
                                style={{
                                  height: 50,
                                  width: "100%",
                                  borderRadius: 10,
                                }}
                              ></div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="d-flex pt-2 mb-4 col-lg-6">
                          <div className="w-50 me-3">
                            {SubmitWishlist ? (
                              <button
                                className="btn btn-accent d-block w-100"
                                type="button"
                                onClick={AddWhishlistData}
                              >
                                <i class="ri-heart-fill"></i> Add to Wishlist
                              </button>
                            ) : (
                              <button
                                class="btn btn-accent d-block w-100"
                                type="button"
                                disabled
                              >
                                <span class="ms-1">Loading...</span>
                                <span
                                  class="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              </button>
                            )}
                          </div>
                          <div className="w-50">
                            {SubmitCompare ? (
                              <button
                                className="btn btn-accent d-block w-100"
                                type="button"
                                onClick={AddCompareData}
                              >
                                <i class="ri-refresh-line"></i> Compare
                              </button>
                            ) : (
                              <button
                                class="btn btn-accent d-block w-100"
                                type="button"
                                disabled
                              >
                                <span class="ms-1">Loading...</span>
                                <span
                                  class="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {Product?.features && Product?.features.length > 0 && <>
                      <h5 className="h6 mb-3 py-2 border-bottom col-md-5">
                        <i className="ri-information-line text-body-secondary fs-lg align-middle me-2" />
                        Key Features
                      </h5>
                      <ul>

                        {Product.features.map((feature) => (
                          <li key={feature._id}>- {feature} </li>
                        ))}
                      </ul>
                    </>
                    }


                    <div class="d-flex mt-2 pt-2 gap-2">
                      <div class="shop-box d-flex gap-2 align-items-center">
                        <div class="shop-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 45 45" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M35.1562 7.73438C36.3206 7.73438 37.2656 8.67937 37.2656 9.84375C37.2656 10.2319 37.5806 10.5469 37.9688 10.5469C38.3569 10.5469 38.6719 10.2319 38.6719 9.84375C38.6719 7.90313 37.0969 6.32812 35.1562 6.32812C34.7681 6.32812 34.4531 6.64312 34.4531 7.03125C34.4531 7.41937 34.7681 7.73438 35.1562 7.73438Z" fill="black"></path>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.2984 35.8597H26.7191C25.554 35.8597 24.6097 36.804 24.6097 37.9691V40.7816C24.6097 41.9466 25.554 42.8909 26.7191 42.8909H29.5316C30.0716 42.8909 30.5644 42.6877 30.9378 42.3537C31.3112 42.6877 31.8041 42.8909 32.3441 42.8909H40.7816C41.9466 42.8909 42.8909 41.9466 42.8909 40.7816V32.3441C42.8909 31.179 41.9466 30.2347 40.7816 30.2347H32.3441C31.179 30.2347 30.2347 31.179 30.2347 32.3441V35.9799C30.0146 35.9019 29.7784 35.8597 29.5316 35.8597H28.8952L24.2982 27.3216L33.0472 18.5726V28.1253C33.0472 28.5134 33.3622 28.8284 33.7503 28.8284C34.1384 28.8284 34.4534 28.5134 34.4534 28.1253V27.593L37.351 24.6948C38.1744 23.8721 38.1744 22.5348 37.351 21.7121C36.5558 20.9162 35.281 20.8894 34.4534 21.6312V17.1664L40.0742 11.5456C40.958 10.6618 41.5599 9.53679 41.8053 8.31194C42.0022 7.32546 42.2539 6.06827 42.4634 5.01921C42.6019 4.32733 42.3854 3.61226 41.8869 3.11374C41.3883 2.61523 40.6733 2.39866 39.9814 2.53718C38.9323 2.74671 37.6751 2.99843 36.6887 3.1953C35.4638 3.44069 34.3388 4.04257 33.455 4.92639L27.8342 10.5472H23.0178C23.7596 9.7196 23.7329 8.44483 22.9369 7.6496C22.1143 6.82624 20.7769 6.82624 19.9543 7.6496L17.056 10.5472H14.9319C15.6737 9.7196 15.6469 8.44483 14.851 7.6496C14.0284 6.82624 12.691 6.82624 11.8684 7.6496L8.97007 10.5472H4.21906C3.25296 10.5472 2.40992 11.2039 2.17367 12.1412C1.93742 13.0777 2.36843 14.0558 3.21922 14.5135L16.6405 21.7409L10.9592 27.4222H4.21906C3.27125 27.4222 2.43945 28.055 2.18633 28.9683C1.9332 29.8824 2.32062 30.8527 3.13343 31.34L6.11257 33.1273C5.30046 34.4668 4.63812 35.8962 4.1396 37.3911L3.89631 38.1216L3.35985 38.6581C2.84587 39.1721 2.50344 39.833 2.38039 40.5495C2.26297 41.2344 2.11953 42.069 2.11953 42.069C2.08086 42.294 2.15398 42.5239 2.3157 42.6849C2.47671 42.8466 2.70664 42.9198 2.93164 42.8811L4.45108 42.6202C5.16756 42.4972 5.8285 42.1548 6.34249 41.6408L6.87897 41.105L7.61023 40.861C9.10507 40.3625 10.5345 39.7001 11.8733 38.8887L13.6606 41.8672C14.1479 42.68 15.1182 43.0674 16.0323 42.8143C16.9456 42.5612 17.5784 41.7294 17.5784 40.7816V34.0414L23.2597 28.3601L27.2984 35.8597ZM38.6722 31.6409V32.9066C38.6722 33.3172 38.509 33.7102 38.2194 34.0006C37.929 34.2903 37.5352 34.4534 37.1253 34.4534H36.0003C35.5904 34.4534 35.1966 34.2903 34.9063 34.0006C34.6166 33.7102 34.4534 33.3172 34.4534 32.9066V31.6409H32.3441C31.9559 31.6409 31.6409 31.9559 31.6409 32.3441V40.7816C31.6409 41.1697 31.9559 41.4847 32.3441 41.4847H40.7816C41.1697 41.4847 41.4847 41.1697 41.4847 40.7816V32.3441C41.4847 31.9559 41.1697 31.6409 40.7816 31.6409H38.6722ZM26.7191 37.2659H29.5316C29.9197 37.2659 30.2347 37.5809 30.2347 37.9691V40.7816C30.2347 41.1697 29.9197 41.4847 29.5316 41.4847H26.7191C26.3309 41.4847 26.0159 41.1697 26.0159 40.7816V37.9691C26.0159 37.5809 26.3309 37.2659 26.7191 37.2659ZM16.1722 35.4476L15.8537 35.7662C14.9874 36.6324 14.0495 37.4192 13.0517 38.1195L14.8665 41.1437C15.0289 41.4144 15.3523 41.5437 15.6568 41.4594C15.9612 41.375 16.1722 41.0973 16.1722 40.7816V35.4476ZM4.21344 41.2344L3.67414 41.3265L3.76624 40.7872C3.84006 40.3569 4.04538 39.961 4.35405 39.6523L9.34695 34.6594C9.62117 34.3852 10.0669 34.3852 10.3412 34.6594C10.6154 34.9337 10.6154 35.3794 10.3412 35.6537L5.34827 40.6466C5.0396 40.9552 4.64375 41.1605 4.21344 41.2344ZM9.31882 38.6651C11.3712 37.6998 13.2472 36.3835 14.8594 34.7712L39.08 10.5514C39.7669 9.86374 40.2352 8.98905 40.4258 8.03632L41.0846 4.74359C41.131 4.51296 41.0586 4.2746 40.8926 4.10796C40.726 3.94202 40.4877 3.8696 40.257 3.91601L36.9643 4.57483C36.0116 4.76538 35.1369 5.23366 34.4492 5.92061L22.5854 17.7844C22.3112 18.0587 21.8654 18.0587 21.5912 17.7844C21.3169 17.5102 21.3169 17.0644 21.5912 16.7902L26.428 11.9534H4.21906C3.89703 11.9534 3.61578 12.1721 3.53703 12.485C3.45828 12.7972 3.60242 13.1227 3.88578 13.2753L17.679 20.7024L19.6027 18.7787C19.8769 18.5044 20.3227 18.5044 20.5969 18.7787C20.8712 19.0529 20.8712 19.4987 20.5969 19.7729L10.2294 30.1405C8.61711 31.7527 7.30155 33.6287 6.33616 35.6818L8.35273 33.6652C9.17538 32.8419 10.5127 32.8419 11.3354 33.6652C12.1587 34.4879 12.1587 35.8252 11.3354 36.6479L9.31882 38.6651ZM37.2659 31.6409V32.9066C37.2659 32.9438 37.2512 32.9797 37.2245 33.0064C37.1984 33.0324 37.1626 33.0472 37.1253 33.0472H36.0003C35.9631 33.0472 35.9272 33.0324 35.9012 33.0064C35.8744 32.9797 35.8597 32.9438 35.8597 32.9066V31.6409H37.2659ZM9.55296 28.8284H4.21906C3.90335 28.8284 3.62563 29.0394 3.54125 29.3438C3.45688 29.6483 3.58623 29.9717 3.85694 30.1341L6.88178 31.9489C7.58069 30.9519 8.3682 30.0132 9.23515 29.1462L9.55296 28.8284ZM34.4534 25.6039V23.6155L35.3626 22.7063C35.6368 22.4321 36.0826 22.4321 36.3568 22.7063C36.631 22.9805 36.631 23.4263 36.3568 23.7005L34.4534 25.6039ZM12.9477 10.5472H10.9592L12.8626 8.64382C13.1368 8.3696 13.5826 8.3696 13.8568 8.64382C14.131 8.91804 14.131 9.36382 13.8568 9.63804L12.9477 10.5472ZM21.0336 10.5472H19.0452L20.9485 8.64382C21.2227 8.3696 21.6685 8.3696 21.9427 8.64382C22.2169 8.91804 22.2169 9.36382 21.9427 9.63804L21.0336 10.5472Z" fill="black"></path>
                          </svg>
                        </div>
                        <div class="shop-content">
                          <h6 class="small-title mb-0">FREE</h6>
                          <span class="text">Shipping</span>
                        </div>
                      </div>

                      <div class="shop-box gap-2 d-flex align-items-center m-0">
                        <div class="shop-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 50 50" fill="none">
                            <path d="M47.9152 37.3125C47.9568 38.875 47.5401 40.3542 46.7901 41.625C46.3735 42.375 45.811 43.0626 45.186 43.6251C43.7485 44.9584 41.8526 45.7709 39.7485 45.8334C36.7068 45.8959 34.0193 44.3334 32.5401 41.9376C31.7485 40.7084 31.2693 39.2293 31.2485 37.6668C31.186 35.0418 32.3526 32.6667 34.2276 31.1042C35.6443 29.9375 37.436 29.2084 39.3943 29.1667C43.9985 29.0626 47.811 32.7083 47.9152 37.3125Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M36.332 37.5625L38.4362 39.5624L42.7904 35.354" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M6.60547 15.5005L25.0013 26.1463L43.2721 15.5629" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M25 45.0213V26.1255" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M45.0221 19.1045V30.8962C45.0221 31.0004 45.0221 31.0836 45.0013 31.1878C43.5429 29.917 41.6679 29.167 39.5846 29.167C37.6263 29.167 35.8138 29.8545 34.3763 31.0004C32.4596 32.5212 31.2513 34.8754 31.2513 37.5004C31.2513 39.0629 31.6887 40.542 32.4596 41.792C32.6471 42.1254 32.8763 42.4379 33.1263 42.7296L29.3138 44.8337C26.9388 46.1671 23.0638 46.1671 20.6888 44.8337L9.56376 38.667C7.04293 37.2712 4.98047 33.7712 4.98047 30.8962V19.1045C4.98047 16.2295 7.04293 12.7295 9.56376 11.3337L20.6888 5.16699C23.0638 3.83366 26.9388 3.83366 29.3138 5.16699L40.4388 11.3337C42.9596 12.7295 45.0221 16.2295 45.0221 19.1045Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                          </svg>
                        </div>
                        <div class="shop-content">
                          <h6 class="small-title mb-0">Easy Returns</h6>
                          <span class="text">30 Days</span>
                        </div>
                      </div>
                    </div>

                    {/* Info List */}
                  </div>

                </div>
              </div>
            </div>
          </section>




          <section className="content-inner-3 pb-0">
            <div className="container">
              <div className="product-description">
                <div className="dz-tabs">
                  <ul className="nav nav-tabs center" id="myTab1" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="home-tab-pane"
                        aria-selected="true"
                        fdprocessedid="t2dq0b"
                      >
                        Description
                      </button>
                    </li>
                  </ul>


                  <div className="mb-4 py-4"
                    dangerouslySetInnerHTML={{ __html: Product?.description }}
                  />

                </div>
              </div>
            </div>
          </section>


        </div>
        <Footer />
      </main>



    </>
  );
};

export default ProductSlug;
